import React from "react";
import { Table } from "antd";
import moment from "moment";
import * as R from "ramda";
import "../styles/components/uptime-table.scss";

const columns = [
  {
    title: "From",
    dataIndex: "from_time",
    key: "from",
    render: data => (
      <p>{moment(data).format("dddd, MMMM Do YYYY, h:mm:ss a")}</p>
    )
  },
  {
    title: "To",
    dataIndex: "to_time",
    key: "to",
    render: data => (
      <p>{moment(data).format("dddd, MMMM Do YYYY, h:mm:ss a")}</p>
    )
  },
  {
    title: "Duration",
    key: "duration",
    dataIndex: "duration"
  }
];

const UptimeTable = ({ downtimes }) => {
  const data = R.map(
    el => ({
      ...el,
      duration: moment
        .utc(moment(el.to_time).diff(moment(el.from_time)))
        .format("HH:mm:ss")
    }),
    downtimes
  );
  return (
    <>
      {!R.isEmpty(downtimes) ? (
        <Table
          columns={columns}
          dataSource={data.reverse()}
          pagination={downtimes.length > 10}
        />
      ) : (
        undefined
      )}
    </>
  );
};

export default UptimeTable;
